export type Prioritet = {
    id: number;
    displayName: string;
    dagar: number;
};

export const convertPrioritetData = ({ prioritet }: { prioritet: Prioritet }) => {
    if (!prioritet) {
        return null;
    }

    return {
        value: prioritet.id,
        label: prioritet.displayName,
        dagar: prioritet.dagar,
    };
};
